function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import { createVNode as _createVNode, mergeProps as _mergeProps } from "vue";
import { ref, watch, computed, nextTick, onMounted, defineComponent } from "vue";
import { pick, clamp, extend, padZero, createNamespace, makeNumericProp } from "../utils";
import { times, sharedProps, pickerInheritKeys, proxyPickerMethods } from "./utils";
import { useExpose } from "../composables/use-expose";
import { Picker } from "../picker";

var _createNamespace = createNamespace("time-picker"),
    _createNamespace2 = _slicedToArray(_createNamespace, 1),
    name = _createNamespace2[0];

var stdin_default = defineComponent({
  name: name,
  props: extend({}, sharedProps, {
    minHour: makeNumericProp(0),
    maxHour: makeNumericProp(23),
    minMinute: makeNumericProp(0),
    maxMinute: makeNumericProp(59),
    modelValue: String
  }),
  emits: ["confirm", "cancel", "change", "update:modelValue"],
  setup: function setup(props, _ref) {
    var emit = _ref.emit,
        slots = _ref.slots;

    var formatValue = function formatValue(value) {
      var minHour = props.minHour,
          maxHour = props.maxHour,
          maxMinute = props.maxMinute,
          minMinute = props.minMinute;

      if (!value) {
        value = "".concat(padZero(minHour), ":").concat(padZero(minMinute));
      }

      var _value$split = value.split(":"),
          _value$split2 = _slicedToArray(_value$split, 2),
          hour = _value$split2[0],
          minute = _value$split2[1];

      hour = padZero(clamp(+hour, +minHour, +maxHour));
      minute = padZero(clamp(+minute, +minMinute, +maxMinute));
      return "".concat(hour, ":").concat(minute);
    };

    var picker = ref();
    var currentDate = ref(formatValue(props.modelValue));
    var ranges = computed(function () {
      return [{
        type: "hour",
        range: [+props.minHour, +props.maxHour]
      }, {
        type: "minute",
        range: [+props.minMinute, +props.maxMinute]
      }];
    });
    var originColumns = computed(function () {
      return ranges.value.map(function (_ref2) {
        var type = _ref2.type,
            rangeArr = _ref2.range;
        var values = times(rangeArr[1] - rangeArr[0] + 1, function (index) {
          return padZero(rangeArr[0] + index);
        });

        if (props.filter) {
          values = props.filter(type, values);
        }

        return {
          type: type,
          values: values
        };
      });
    });
    var columns = computed(function () {
      return originColumns.value.map(function (column) {
        return {
          values: column.values.map(function (value) {
            return props.formatter(column.type, value);
          })
        };
      });
    });

    var updateColumnValue = function updateColumnValue() {
      var pair = currentDate.value.split(":");
      var values = [props.formatter("hour", pair[0]), props.formatter("minute", pair[1])];
      nextTick(function () {
        var _a;

        (_a = picker.value) == null ? void 0 : _a.setValues(values);
      });
    };

    var updateInnerValue = function updateInnerValue() {
      var _picker$value$getInde = picker.value.getIndexes(),
          _picker$value$getInde2 = _slicedToArray(_picker$value$getInde, 2),
          hourIndex = _picker$value$getInde2[0],
          minuteIndex = _picker$value$getInde2[1];

      var _originColumns$value = _slicedToArray(originColumns.value, 2),
          hourColumn = _originColumns$value[0],
          minuteColumn = _originColumns$value[1];

      var hour = hourColumn.values[hourIndex] || hourColumn.values[0];
      var minute = minuteColumn.values[minuteIndex] || minuteColumn.values[0];
      currentDate.value = formatValue("".concat(hour, ":").concat(minute));
      updateColumnValue();
    };

    var onConfirm = function onConfirm() {
      return emit("confirm", currentDate.value);
    };

    var onCancel = function onCancel() {
      return emit("cancel");
    };

    var onChange = function onChange() {
      updateInnerValue();
      nextTick(function () {
        nextTick(function () {
          return emit("change", currentDate.value);
        });
      });
    };

    onMounted(function () {
      updateColumnValue();
      nextTick(updateInnerValue);
    });
    watch(columns, updateColumnValue);
    watch(function () {
      return [props.filter, props.maxHour, props.minMinute, props.maxMinute];
    }, updateInnerValue);
    watch(function () {
      return props.minHour;
    }, function () {
      nextTick(updateInnerValue);
    });
    watch(currentDate, function (value) {
      return emit("update:modelValue", value);
    });
    watch(function () {
      return props.modelValue;
    }, function (value) {
      value = formatValue(value);

      if (value !== currentDate.value) {
        currentDate.value = value;
        updateColumnValue();
      }
    });
    useExpose({
      getPicker: function getPicker() {
        return picker.value && proxyPickerMethods(picker.value, updateInnerValue);
      }
    });
    return function () {
      return _createVNode(Picker, _mergeProps({
        "ref": picker,
        "columns": columns.value,
        "onChange": onChange,
        "onCancel": onCancel,
        "onConfirm": onConfirm
      }, pick(props, pickerInheritKeys)), slots);
    };
  }
});
export { stdin_default as default };